<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <div class="ma-6">
        <v-card elevation="6">
          <v-form ref="profile" @submit.prevent="update_profile">
            <v-card-title>
              ข้อมูลส่วนตัว
            </v-card-title>
            <div class="pa-3">
              <div>
                <div class="grid_flex">
                  <div class="d-flex">
                    <v-icon>mdi-account</v-icon>
                    <div v-if="$store.state.status === 1" class="ma-1">รหัสผู้ดูแลระบบ :</div>
                    <div v-else-if="$store.state.status === 2" class="ma-1">รหัสพนักงาน :</div>
                    <div v-else class="ma-1">รหัส :</div>
                  </div>
                  <div class="ma-1">{{ user_data.user_code }}</div>
                </div>
              </div>
              <div class="grid_half mt-4">
                <div class="mt-3 mr-3 ml-3">
                  <v-tooltip right color="black">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field color="#86bc3a" label="ชื่อสำหรับเข้าสู่ระบบ" @paste="isPaste($event)" @keypress="isCharacter($event)" prepend-inner-icon="mdi-account-outline" :rules="loginRules" hide-details="auto" required v-model="user_data.username" outlined>
                        <v-icon color="black lighten-1" slot="append" v-bind="attrs" v-on="on">
                          mdi-alert-circle
                        </v-icon>
                      </v-text-field>
                    </template>
                    <span>กรุณากรอกตัวอักษร A-z ก-ฮ 0-9</span>
                  </v-tooltip>
                </div>
                <div class="mt-3 mr-3 ml-3">
                  <v-text-field color="#86bc3a" label="ชื่อ - สกุล" prepend-inner-icon="mdi-account-outline" hide-details="auto" :rules="[v => !!v || 'กรุณากรอกชื่อ - สกุล']" v-model="user_data.name" required outlined></v-text-field>
                </div>
                <div class="mt-3 mr-3 ml-3">
                  <v-text-field color="#86bc3a" label="เบอร์โทรศัพท์" type="tel" maxlength="10" prepend-inner-icon="mdi-phone-outline" @keypress="isNumber($event, user_data.telephone)" v-model="user_data.telephone" hide-details="auto" outlined></v-text-field>
                </div>
                <div class="mt-3 mr-3 ml-3">
                  <v-text-field color="#86bc3a" label="อีเมล" type="email" prepend-inner-icon="mdi-email-outline" v-model="user_data.email" hide-details="auto" outlined></v-text-field>
                </div>
              </div>
              <v-form ref="password">
                <div class="mt-12">
                  <div class="d-flex">
                    <v-icon>mdi-lock</v-icon>
                    <div class="ml-1">ตั้งรหัสผ่าน</div>
                  </div>
                </div>
                <div class="grid_half mt-4">
                  <div class="mt-3 mr-3 ml-3">
                    <v-text-field clearable color="#86bc3a" v-model="password_new" prepend-inner-icon="mdi-lock-outline" :rules="passwordRules" hide-details="auto" :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'" :type="show ? 'text' : 'password'" name="input-10-1" label="รหัสผ่าน" @click:append="show = !show" required outlined></v-text-field>
                  </div>
                  <div class="mt-3 mr-3 ml-3">
                    <v-text-field clearable color="#86bc3a" v-model="confirmPassword" prepend-inner-icon="mdi-lock-outline" :rules="confirmPasswordRules.concat(passwordConfirmationRule)" hide-details="auto" :append-icon="show_confirm ? 'mdi-eye' : 'mdi-eye-off'" :type="show_confirm ? 'text' : 'password'" name="input-10-1" label="ยืนยันรหัสผ่าน" @click:append="show_confirm = !show_confirm" required outlined></v-text-field>
                  </div>
                </div>
              </v-form>
              <div class="text-center mt-6 mr-1 mb-3">
                <div>
                  <v-btn height="45" class="white--text grad-success-bg btn_mobile" style="font-size: 18px" type="submit" :disabled="!disabled_btn">บันทึก</v-btn>
                </div>
              </div>
            </div>
          </v-form>
        </v-card>
        <v-overlay :value="overlay" class="z_index">
          <div class="text-center">
            <v-progress-circular
                indeterminate
                size="70"
                width="7"
                color="#86bc3a"
            ></v-progress-circular>
            <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
          </div>
        </v-overlay>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import {HTTP} from "@/axios";
import {isTelephone, onPaste, validateCharacter} from "@/js/handler";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "ProfileView",
  data() {
    return {
      show: false,
      overlay: false,
      show_confirm: false,
      loading_page: false,
      disabled_btn: true,
      phoneRules: [v => ( v.length === 10 ) || "เบอร์โทรศัพท์ไม่ถูกต้อง !",],
      emailRules: [v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'อีเมลไม่ถูกต้อง !'],
      loginRules: [
        v => !!v || 'กรุณากรอกชื่อสำหรับเข้าสู่ระบบ',
        v => ( v.length > 2 ) || 'กรุณากรอกตัวอักษรมากกว่า 3 ตัวขึ้นไป',
      ],
      password_new: '',
      confirmPassword: '',
      passwordRules: [v => !!v || "กรุณากรอกรหัสผ่าน"],
      confirmPasswordRules: [v => !!v || "กรุณากรอกรหัสผ่าน"],
      user_data: this.$store.state.userDetail,
    }
  },
  methods: {
    isNumber: function (evt, number) {
      return isTelephone(evt, number)
    },
    isPaste: function (evt) {
      return onPaste(evt)
    },
    isCharacter: function (evt) {
      return validateCharacter(evt)
    },
    async update_profile() {
      this.overlay = true
      if (this.password_new !== '' && this.password_new !== null && this.confirmPassword !== '' && this.confirmPassword !== null) {
        if (this.password_new === this.confirmPassword) {
          await HTTP.post('/users/updateprofile', {
            user_id: this.user_data.id,
            user_name: this.user_data.username,
            name: this.user_data.name,
            telephone: this.user_data.telephone,
            email: this.user_data.email,
            password: this.password_new
          }).then((res) => {
            if (res.data.success === true) {
              this.overlay = false
              const config = {headers: {"Authorization": `Bearer ${this.$store.state.token}`}}
              HTTP.post('/profile', {
                username: this.$store.state.user_data.username,
                password: this.$store.state.user_data.password
              }, config).then((result) => {
                this.$store.state.userDetail = result.data
              })
              Swal.fire({
                title: 'บันทึกข้อมูลเสร็จสิ้น !',
                icon: 'success',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: `ตกลง`,
                denyButtonText: `ยกเลิก`,
              })
            }
          })
        }
        else {
          this.overlay = false
          await Swal.fire({
            title: 'ไม่สามารถดำเนินการได้ !',
            text: 'รหัสผ่านไม่ตรงกัน !',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          })
        }
      }
      else if (this.user_data.username !== null && this.user_data.name !== null && this.user_data.username !== '' && this.user_data.name !== '' && this.user_data.username !== undefined && this.user_data.name !== undefined) {
        await HTTP.post('/users/updateprofile', {
          user_id: this.user_data.id,
          user_name: this.user_data.username,
          name: this.user_data.name,
          telephone: this.user_data.telephone,
          email: this.user_data.email,
          password: this.password_new
        }).then((res) => {
          if (res.data.success === true) {
            this.overlay = false
            const config = {headers: {"Authorization": `Bearer ${this.$store.state.token}`}}
              HTTP.post('/profile', {
              username: this.$store.state.user_data.username,
              password: this.$store.state.user_data.password
            }, config).then((result) => {
              this.$store.state.userDetail = result.data
            })
            Swal.fire({
              title: 'บันทึกข้อมูลเสร็จสิ้น !',
              icon: 'success',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: `ตกลง`,
              denyButtonText: `ยกเลิก`,
            })
          }
        })
      }
      else {
        this.overlay = false
        Swal.fire({
          title: 'ไม่สามารถดำเนินการได้ !',
          text: 'กรุณากรอกข้อมูล !',
          icon: 'error',
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        }).then(() => {
          this.$refs.profile.validate()
        })
      }
    }
  },
  computed: {
    passwordConfirmationRule() {
      return () => this.password_new === this.confirmPassword || "รหัสผ่านไม่ตรงกัน";
    }
  }
}
</script>

<style scoped>
.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
  grid-gap: 15px 0;
  text-align: center;
}
.btn_mobile {
  width: 25%;
}
.grid_flex {
  display: flex;
}
@media only screen and (max-width: 500px) {
  .grid_flex {
    display: flex;
  }
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
    text-align: center;
  }
  .btn_mobile {
    width: 100%;
  }
}
</style>
